import { createFileRoute } from '@tanstack/react-router'
import { CustomerCommunicationDetailPage } from '@/pages/customer-communication-detail'

// A conversation with the customer, under the customer (USA-1695).
export const Route = createFileRoute('/_authenticated/customers/$groupId_/comms/$threadId')({
  staticData: { title: 'Customer Comms' },
  component: CustomerThreadRoute,
  // ``action`` opens the conversation at an action item, ``message`` at an email an action card links to.
  validateSearch: (search: Record<string, unknown>): { action?: string; message?: string } => ({
    action: typeof search.action === 'string' ? search.action : undefined,
    message: typeof search.message === 'string' ? search.message : undefined,
  }),
})

function CustomerThreadRoute() {
  const { threadId } = Route.useParams()
  const { action, message } = Route.useSearch()
  return (
    <CustomerCommunicationDetailPage
      threadId={Number(threadId)}
      actionUuid={action}
      messageId={message ? Number(message) : undefined}
    />
  )
}
